export type PacketLightingSettings = {
  ambientIntensity: number;
  exposure: number;
  fillIntensity: number;
  keyIntensity: number;
  materialBrightness: number;
  materialRoughness: number;
};

export const defaultPacketLightingSettings = {
  ambientIntensity: 0.61,
  exposure: 1.22,
  fillIntensity: 0.76,
  keyIntensity: 1.73,
  materialBrightness: 1.01,
  materialRoughness: 0.48,
} satisfies PacketLightingSettings;
